import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from '../../App.js'
import './index.css'
import COLORS  from '../../colors'
import { Button, TextField, makeStyles } from '@material-ui/core'
import { ReactComponent as Close } from '../../assets/close_gray.svg'
import { isMobile } from 'react-device-detect'

const useStyles = makeStyles((theme) => ({
	input: {
	  	background: COLORS.gray,
	  	borderRadius: '1rem',
	},
	saveBtn:{
		width:'90%', 
        color:"#fff", 
    	fontWeight: 'bold', 
        backgroundColor: COLORS.blue, 
        textTransform: 'none',
		margin:'1rem',
		"&:hover": {
			backgroundColor: COLORS.blue
	  	} 
	}
  }));

const ModalAddArticle = ({ popup, quantityNumber, item, onAdd, onCancle }) => {

	const { incrementQN, lastAddedCartItem } = useContext(AuthContext)
	const [ quantity, setQuantity ] = useState('')
	const [ keypad, setKeypad ] = useState(false)
	const [ isDisabled, setIsDisabled ] = useState(true)
	const [ width, setWidth ] = useState(window.innerWidth);
	const [ height, setHeight ] = useState(window.innerHeight);
	const classes = useStyles()

	useEffect(()=>{
		if(quantity===''||parseInt(quantity)===0){
				setIsDisabled(true)
		}else{
				setIsDisabled(false)
		}
	},[quantity])

	useEffect(()=>{
	 	function hideKeypad(){
			setWidth(window.innerWidth);
    		setHeight(window.innerHeight);	 	 
		}
	 	window.addEventListener('resize', hideKeypad, false)
	 	return () => window.removeEventListener('resize', hideKeypad, false);
	 },[])

	const handleAddArticle = () => {
		console.log("Handle add article...", item.id, quantity)
		lastAddedCartItem({item:item, quantity:parseInt(quantity)})
		incrementQN(quantityNumber + parseInt(quantity))
		onAdd()
		setQuantity('')	
	}

	const handleEnterPress = (event) => {
			if(event.key=='Enter'&&!isDisabled){
				handleAddArticle()
			}
	}
	
	const handleCancle = () => {
			setQuantity('')
			onCancle()
	}

	const handleName = (itemName) => {

		var newName = ""
		if(itemName.length>19)
		{
			newName = itemName.substring(0,19)+'...'
		}else
		{
			newName = itemName
		}

		return newName
	}

	if (!popup) return null
    return (
    			<div className="modal">
					<div className="overlay-add-article-modal" />
					<div className="modal-add-article-body" style={{width:!isMobile?'25rem':'90%', height:!isMobile?(height>820?'18rem':'40%'):'45%'}}>
						<div className="modal-add-article">
						{(!keypad||height>500)?<div className="modal-add-article-title">Upiši broj komada</div>:
								<div className="modal-add-article-title-on-keypad">Upiši broj komada</div>}
						{(!keypad||height>500)&&<Close className="add-article-close-btn" onClick={()=>handleCancle()}/>}
						</div>	
						<div className="modal-add-article-heading">
							<div className="modal-add-article-heading-name">{handleName(item.name)}</div>
							<div className="modal-add-article-heading-price">{item.price} EUR</div>
						</div>
						<TextField  label="Broj komada" 
								    variant="outlined"
									type="number"
									style={{
										width:'90%'
									}}
								    InputProps = {{
										className: classes.input,
									}}
									value={quantity}
									onFocus={()=>setKeypad(true)}
									onBlur={()=>setKeypad(false)}
									onKeyPress={event=>handleEnterPress(event)}
									onChange={(event)=>setQuantity(event.target.value.replace(/[^0-9]/g, ''))}	        
						/>
						{(!keypad||height>500)&&<Button size="large" 
                 									variant="contained"
													className={classes.saveBtn}
													disabled={isDisabled}
													onClick={() => handleAddArticle()}
						>SPREMI</Button> }
						{(!keypad||height>500)&&<Button size="large" 
                 										variant="contained"
                 										style={{ width:'90%', 
                             									color:"#000", 
                             									fontWeight: 'bold', 
                             									backgroundColor:'#fff',
																border: '2px solid #2F2F5B', 
																marginBottom: '1rem',
                     		 									textTransform: 'none',
																"&:hover": {
																	backgroundColor: '#fff'
															  	} 
                       									}}
														 
														onClick={() => handleCancle()}
												>ODUSTANI</Button>}	
					</div>
    			</div>
	)
}

export default ModalAddArticle
